import { render, staticRenderFns } from "./CopyStakeWebStreamersView.vue?vue&type=template&id=7ab227c2&scoped=true&lang=pug"
import script from "./CopyStakeWebStreamersView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWebStreamersView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWebStreamersView.vue?vue&type=style&index=0&id=7ab227c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab227c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
